export const routes = {
  home: "/",
  playground: "/playground",
};
